/**
 * Shared constants for chunk-load-error recovery across lazyWithRetry,
 * chunkErrorHandler, and ChunkErrorBoundary. Keep this as the single source
 * of truth to ensure all layers classify errors consistently and prevent
 * reload loops.
 */

/**
 * sessionStorage key set when a recovery reload is triggered in a tab session.
 * Prevents infinite reload loops by tracking whether recovery has been attempted.
 * Cleared on bfcache restore or when the user manually reloads.
 */
export const RELOAD_FLAG = "chunk_reload_attempted";

/**
 * Prefix for per-route sessionStorage keys set by lazyWithRetry.
 * Each route gets its own key for independent recovery tracking.
 */
export const RELOAD_FLAG_PREFIX = "chunk_lazy_retry_";

/**
 * Error message patterns that identify post-deploy stale-chunk failures
 * across all browsers (Safari, Chrome/Edge, Firefox) and Vite CSS chunks.
 */
export const CHUNK_ERROR_PATTERNS = [
  "Importing a module script failed",
  "Failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "Unable to preload CSS for",
];

/**
 * Returns true if an error message indicates a stale-chunk failure.
 * Used by all recovery layers to classify errors consistently.
 */
export function isChunkErrorMessage(message: string): boolean {
  return CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}
